import { Context } from "@silvertours/front-shared";
// have to do this because type assertion functions have some stupid restrictions
var hasContext = Context.guardContext;
export var useRuntime = function() {
    var result = Context.useClientContext("runtime");
    hasContext("runtime", result);
    return result.value;
};
